export default class GenogramTileDecoder {

	constructor(options = {}) {
		this.logger = options.logger || null
		this.canvas = document.createElement("canvas")
		this.ctx = this.canvas.getContext("2d", {willReadFrequently: true})
	}

	async decodeBlob(blob) {
		let startedAt = Date.now()
		let bitmap = await createImageBitmap(blob)
		let imageData = this.readBitmapImageData(bitmap, {
			backgroundColor: "white",
		})
		bitmap.close()
		this.logger?.log("TileDecoded", {
			width: imageData.width,
			height: imageData.height,
			blobBytes: blob?.size,
			rawBytes: imageData.data?.byteLength,
			durationMs: Date.now() - startedAt,
		})
		return imageData
	}

	async decodeTileBlob(tile) {
		let decodedImageData = await this.decodeBlob(tile?.blob)
		let plannedWidth = tile?.width || 0
		let plannedHeight = tile?.height || 0
		let widthRatio = plannedWidth > 0 ? decodedImageData.width / plannedWidth : null
		let heightRatio = plannedHeight > 0 ? decodedImageData.height / plannedHeight : null
		let payload = {
			tileIndex: tile?.index,
			row: tile?.row,
			column: tile?.column,
			plannedWidth,
			plannedHeight,
			decodedWidth: decodedImageData.width,
			decodedHeight: decodedImageData.height,
			widthRatio,
			heightRatio,
		}

		if (plannedWidth !== decodedImageData.width || plannedHeight !== decodedImageData.height) {
			this.logger?.warn("TileDecodedSizeMismatch", payload)
		} else {
			this.logger?.log("TileDecodedSizeMatch", payload)
		}

		this.logger?.log("TilePreserved", {
			tileIndex: tile?.index,
			row: tile?.row,
			column: tile?.column,
			width: decodedImageData.width,
			height: decodedImageData.height,
			rawBytes: decodedImageData.data?.byteLength,
		})

		return decodedImageData
	}

	async decodeSource(source) {
		let startedAt = Date.now()
		let image = await this.getImageFromSource(source)
		let imageData = this.readImageElementData(image)
		this.logger?.log("ImageSourceDecoded", {
			width: imageData.width,
			height: imageData.height,
			rawBytes: imageData.data?.byteLength,
			durationMs: Date.now() - startedAt,
		})
		return imageData
	}

	readBitmapImageData(bitmap, options = {}) {
		return this.readImageData(bitmap, bitmap.width, bitmap.height, options)
	}

	readImageElementData(image, options = {}) {
		return this.readImageData(image, image.width, image.height, options)
	}

	readImageData(imageSource, width, height, options = {}) {
		let backgroundColor = options.backgroundColor || null
		this.canvas.width = width
		this.canvas.height = height
		this.ctx.clearRect(0, 0, width, height)
		if (backgroundColor) {
			this.ctx.fillStyle = backgroundColor
			this.ctx.fillRect(0, 0, width, height)
		}
		this.ctx.drawImage(imageSource, 0, 0, width, height)
		let imageData = this.ctx.getImageData(0, 0, width, height)

		return {
			width,
			height,
			data: imageData.data,
		}
	}

	getImageFromSource(imgSrc) {
		return new Promise((resolve, reject) => {
			let image = new Image()
			image.onload = () => resolve(image)
			image.onerror = reject
			image.src = imgSrc
		})
	}

	async getBlobDimensions(blob) {
		let bitmap = await createImageBitmap(blob)
		let dimensions = {
			width: bitmap.width,
			height: bitmap.height,
		}
		bitmap.close()

		return dimensions
	}

	destroy() {
		if (this.canvas) {
			this.canvas.width = 0
			this.canvas.height = 0
		}
		this.ctx = null
		this.canvas = null
	}
}
